import React, { useEffect, useRef, useState } from "react";
import {
  _LandingEngagementsProductList,
  _LandingEngagementsRoot,
} from "./LandingEngagements.styled";
import Typography from "../../../Foundation/Typography/Typography";
import HighlightedTypography from "../../HighlightedTypography/HighlightedTypography";
import { useHighlightedTypographyContext } from "../../HighlightedTypography";
import htmlParse from "html-react-parser";
import clsx from "clsx";
import FlexBox from "../../FlexBox/FlexBox";
import EngagementItem from "./EngagementItem/EngagementItem";
import Siema from "siema";
import useBreakpoint from "../../Grid/hooks/useBreakpoint";
import SliderDot from "../../../Core/ProductDetails/ProductDetailsImages/SliderDot/SliderDot";

export interface ILandingEngagementItem {
  imageId: string;
  title: string;
  subtitle?: string;
  url?: string
}

interface ILandingEngagementsProps {
  title: string;
  highlightedTitle?: string;
  description?: string;
  engagements?: ILandingEngagementItem[];
}
const LandingEngagements = (props: ILandingEngagementsProps) => {
  const { title, highlightedTitle, description, engagements = [] } = props;
  const slider = useRef<Siema | null>(null);
  const sliderElement = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const { isMobile } = useBreakpoint();
  const { highlightedColor } = useHighlightedTypographyContext();

  const slideCount = engagements.length;
  const useSlider = slideCount > 1;

  useEffect(() => {
    setTimeout(() => {
      if (isMobile) {
        if (useSlider && sliderElement.current && !slider.current && isMobile) {
          slider.current = new Siema({
            selector: sliderElement.current,
            multipleDrag: false,
            duration: 400,
            easing: "ease-out",
            startIndex: 0,
            perPage: 1,
            draggable: true,
            threshold: 20,
            loop: false,
            rtl: false,
            onInit: () => {
              setActiveIndex(0);
            },
            onChange: () => {
              if (slider.current) {
                setActiveIndex(slider.current.currentSlide);
              }
            },
          });
        }
      } else {
        if (slider.current) {
          slider.current?.destroy(true);
          slider.current = null;
        }
      }
    }, 300);
  }, [useSlider, isMobile, sliderElement.current]);

  return (
    <_LandingEngagementsRoot
      className="landing-engagements"
      $linkColor={highlightedColor}
    >
      <div className={clsx("landing-engagements__container")}>
        {/* header */}
        <FlexBox
          direction="column"
          align="center"
          className="landing-engagements__header"
        >
          <HighlightedTypography
            variant="h4"
            align="center"
            highlightedText={highlightedTitle}
            className="landing-engagements__title"
          >
            {title}
          </HighlightedTypography>
          <Typography
            variant="body"
            align="center"
            className="landing-engagements__description"
          >
            {htmlParse(description + "")}
          </Typography>
        </FlexBox>

        {/* Product list */}
        <_LandingEngagementsProductList style={{ width: "100%" }}>
          {isMobile ? (
            <>
              <div ref={sliderElement} style={{ marginBottom: 24 }}>
                {engagements?.map((engagement, index) => {
                  return (
                    <EngagementItem
                      key={index}
                      engagement={engagement}
                      style={{
                        margin: "0 auto",
                      }}
                    />
                  );
                })}
              </div>
              <SliderDot
                className="product-details__slider-dot"
                total={slideCount}
                current={activeIndex}
              />
            </>
          ) : (
            <FlexBox
              justify="center"
              style={{
                maxWidth: 1206,
                width: "100%",
                scrollSnapAlign: "start",
                margin: "0 auto",
              }}
            >
              <FlexBox
                className={"engagements-product-list-wrapper"}
                justify={"space-between"}
                style={{ width: "100%" }}
              >
                {engagements?.map((engagement, index) => {
                  return <EngagementItem key={index} engagement={engagement} />;
                })}
              </FlexBox>
            </FlexBox>
          )}
        </_LandingEngagementsProductList>
      </div>
    </_LandingEngagementsRoot>
  );
};

export default LandingEngagements;
